module.exports = __webpack_public_path__ + "static/3-4-be0054498ab9e6ee38f08d97aea3d676.jpg";